// extracted by mini-css-extract-plugin
export default {"contentTitle":"SubsectionTitle_contentTitle__5qxZt"};